import { Button } from "antd";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { useError } from "./ErrorProvider";

function ErrorFallback() {
  const { error, resetError } = useError();
  const { customerId, organizationId, sport, seasonId } = useParams();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  let backLink = "/";
  if (customerId) {
    backLink = `/${customerId}/select/organization`;
  }
  if (organizationId) {
    backLink = `/${customerId}/admin/${sport}/${organizationId}/dashboard`;
  }
  if (seasonId) {
    backLink = `/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/`;
  }

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        marginTop: 40,
        padding: "2em",
        textAlign: "center",
        color: "red",
      }}
    >
      <div style={{ width: 400 }}>
        <h1>Something went wrong.</h1>
        {error && <p>{error.message}</p>}
        <Button
          type="primary"
          onClick={() => {
            resetError();
            navigate(backLink);
          }}
        >
          {formatMessage({ id: "back" })}
        </Button>
      </div>
    </div>
  );
}

export default ErrorFallback;
